import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { ACTIVITIES_ACTION_TYPE } from '../actions';

const initialState = {};

const activitiesReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case ACTIVITIES_ACTION_TYPE.GET_ACTIVITIES:
        return payload;

      case ACTIVITIES_ACTION_TYPE.GET_EMAIL_ACTIVITIES: {
        Object.keys(payload).forEach(id => {
          if (!draft[id]) {
            draft[id] = payload[id];
          }
        });

        break;
      }

      case ACTIVITIES_ACTION_TYPE.PATCH_ACTIVITIES: {
        payload.ids.forEach(id => {
          if (draft[id]) {
            draft[id] = {
              ...draft[id],
              ...payload.patches[id],
            };
          }
        });

        break;
      }

      case RESET_STATE:
      case ACTIVITIES_ACTION_TYPE.RESET_ACTIVITIES:
        return initialState;

      default:
        return state;
    }
  });

export default activitiesReducer;
